import { render, staticRenderFns } from "./BaseEditTemplate.vue?vue&type=template&id=7afdc2bc&"
import script from "./BaseEditTemplate.vue?vue&type=script&lang=js&"
export * from "./BaseEditTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Server\\domains\\localhost\\ss\\wa-apps\\shop\\plugins\\giftcertificates\\build\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7afdc2bc')) {
      api.createRecord('7afdc2bc', component.options)
    } else {
      api.reload('7afdc2bc', component.options)
    }
    module.hot.accept("./BaseEditTemplate.vue?vue&type=template&id=7afdc2bc&", function () {
      api.rerender('7afdc2bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/base/BaseEditTemplate.vue"
export default component.exports